import React, { Component } from 'react';
import Modal from '../../../components/modals';
import { gql } from '@apollo/client';
import _ from 'lodash';
import { ReactComponent as CheckedIcon } from '../../../../assets/svg/checked-purple.svg';
import { ReactComponent as BellIcon } from '../../../../assets/svg/bell.svg';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';

class NotifyShootCrew extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			selectedCrew: [],
		};
	}
	componentDidMount = () => {};
	handleCloseModal = () => {
		this.props.handleClose();
	};
	toggleAllSelected = () => {
		let selectedCrew = [];
		if (
			_.size(this.state.selectedCrew) ===
			_.size(this.props.notifyDetails.eventDetails.crewDetails)
		) {
			selectedCrew = [];
		} else {
			selectedCrew = _.map(
				this.props.notifyDetails.eventDetails.crewDetails,
				(item, index) => {
					let found = undefined;
					found = _.find(this.props.tenantUsersList, { key: item.id });
					if (found) {
						return { phoneNumber: found.phoneNumber, id: item.id };
					} else {
						return { phoneNumber: '', id: item.id };
					}
				},
			);
		}

		this.setState({ selectedCrew });
	};

	handleToggleSelected = (id) => {
		let selectedCrew = this.state.selectedCrew;

		let found = -1;
		found = _.findIndex(this.state.selectedCrew, { id: id });
		if (found === -1) {
			let found = undefined;
			found = _.find(this.props.tenantUsersList, { key: id });
			let tempObj = {};
			if (found) {
				tempObj = { phoneNumber: found.phoneNumber, id: id };
			} else {
				tempObj = { phoneNumber: '', id: id };
			}
			selectedCrew.push(tempObj);
		} else {
			selectedCrew.splice(found, 1);
		}
		this.setState({ selectedCrew });
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div className="notify-shoot-crew-modal">
					<div className="notify-header">
						<span className="inner-header">
							<span className="bell-icn">
								<BellIcon />
							</span>
							<span className="header-text">NOTIFY CREW</span>
						</span>
					</div>
					<div className="outer-crew-container">
						<div className="crew-item">
							{_.size(this.state.selectedCrew) ===
							_.size(this.props.notifyDetails.eventDetails.crewDetails) ? (
								<span
									className="check-box-icn"
									onClick={() => this.toggleAllSelected()}
								>
									<CheckedIcon />
								</span>
							) : (
								<span
									className="empty-check-box"
									onClick={() => this.toggleAllSelected()}
								></span>
							)}
							<span>ALL CREW</span>
						</div>
					</div>
					<div className="outer-crew-container">
						{_.map(this.props.notifyDetails.eventDetails.crewDetails, (item, index) => {
							let isChecked = false;
							if (_.find(this.state.selectedCrew, { id: item.id }) !== undefined) {
								isChecked = true;
							}
							return (
								<div className="crew-item">
									{isChecked ? (
										<span
											className="check-box-icn"
											onClick={() => this.handleToggleSelected(item.id)}
										>
											<CheckedIcon />
										</span>
									) : (
										<span
											className="empty-check-box"
											onClick={() => this.handleToggleSelected(item.id)}
										></span>
									)}
									<span className={isChecked ? '' : 'unselected-crew-text'}>
										{item.name} ({item.subRole[0] + item.role[0]})
									</span>
								</div>
							);
						})}
					</div>
					<div className="notify-crew-tail">
						<span className="cancel-btn" onClick={() => this.props.handleClose()}>
							Cancel
						</span>
						<span
							className="submit-btn"
							onClick={() => {
								if (_.size(this.state.selectedCrew) > 0) {
									let notifyDetails = _.cloneDeep(this.props.notifyDetails);
									delete notifyDetails.eventDetails;
									this.props.notifyCrew({
										...notifyDetails,
										crewPhNumber: _.map(
											this.state.selectedCrew,
											(item) => item.phoneNumber,
										),
									});
								}
							}}
						>
							Notify Selected Crew
						</span>
					</div>
				</div>
			</Modal>
		);
	}
}

export default NotifyShootCrew;
